const humanResourcesRouter = [
  {
    path: '/human-resources',
    name: 'humanResources',
    component: () => import('@/views/wxapp/human-resources/'),
    redirect: '/human-resources/home',
    meta: {
      title: '人力资源'
    },
    children: [
      {
        path: 'home',
        name: 'humanResourcesHome',
        component: () => import('@/views/wxapp/human-resources/home/index'),
        meta: {
          title: '入职登记'
        }
      },
      {
        path: 'shopowner-details',
        name: 'shopownerDetails',
        component: () => import('@/views/wxapp/human-resources/home/shopowner-details'),
        meta: {
          title: '合伙人店长'
        }
      },
      {
        path: 'clerk-details',
        name: 'clerkDetails',
        component: () => import('@/views/wxapp/human-resources/home/clerk-details'),
        meta: {
          title: '合伙人店员'
        }
      },
      {
        path: 'staff-details',
        name: 'staffDetails',
        component: () => import('@/views/wxapp/human-resources/home/staff-details'),
        meta: {
          title: '员工'
        }
      }
    ]
  }
]
export default humanResourcesRouter
